import { render, staticRenderFns } from "./XAdminInfo.vue?vue&type=template&id=8570f8f0&scoped=true"
import script from "./XAdminInfo.vue?vue&type=script&lang=js"
export * from "./XAdminInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8570f8f0",
  null
  
)

export default component.exports